<template>
	<div
		class="g-block-pay-jumplink-featured"
		:class="{
			'g-block-pay-jumplink-featured--edit': editable,
			'is-active': editable && active,
			'g-block-pay-jumplink-featured--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-pay-jumplink-featured__card">
			<div class="g-block-pay-jumplink-featured__badge" :style="badgeStyle">
				<i class="mbm-iconfont mbm-shoucang2"></i>
				<span>{{ data.badgeText || '精选资料' }}</span>
			</div>

			<div class="g-block-pay-jumplink-featured__main">
				<div class="g-block-pay-jumplink-featured__main-left">
					<p class="g-block-pay-jumplink-featured__title">{{ data.title || 'AI短剧实战资料包' }}</p>
					<p class="g-block-pay-jumplink-featured__subtitle">{{ data.subtitle || '付费后跳转查看完整内容' }}</p>
				</div>
				<span v-if="!isGeditModulePaid && !shouldHidePrice" class="g-block-pay-jumplink-featured__price">
					<span class="g-block-pay-jumplink-featured__currency">¥</span>
					<span class="g-block-pay-jumplink-featured__integer">{{ priceParts.integer }}</span>
					<span class="g-block-pay-jumplink-featured__decimal">{{ priceParts.decimal }}</span>
				</span>
			</div>

			<div class="g-block-pay-jumplink-featured__divider"></div>

			<div class="g-block-pay-jumplink-featured__footer">
				<div class="g-block-pay-jumplink-featured__assurance">
					<i class="mbm-iconfont mbm-iconfontanquan" :style="{ color: btnColor }"></i>
					<span>{{ data.assuranceText || '支付成功后可跳转' }}</span>
				</div>
				<div
					class="g-block-pay-jumplink-featured__btn"
					:style="buttonStyle"
					@click.stop="onButtonClick"
				>
					<span>{{ (isGeditModulePaid ? data.unlockedButtonText : '') || data.buttonText || '立即解锁' }}</span>
					<span class="g-block-pay-jumplink-featured__btn-arrow">
						<i class="mbm-iconfont mbm-youjiantou1" :style="{ color: btnColor }"></i>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor } from '../shared/utils.js';
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import { DEFAULT_PAY_UNLOCK_JUMPLINK_FEATURED } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockJumpLinkFeatured',
		mixins: [payUnlockMixin],
		computed: {
			defaultButtonColors() {
				return DEFAULT_PAY_UNLOCK_JUMPLINK_FEATURED;
			},
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_JUMPLINK_FEATURED);
			},
			badgeStyle() {
				return { background: this.btnColor };
			},
			buttonStyle() {
				return {
					background: this.btnColor,
					color: '#fff',
				};
			},
			priceParts() {
				const price = formatPayPrice(this.data.price ?? DEFAULT_PAY_UNLOCK_JUMPLINK_FEATURED.price);
				const [integer, decimal = '00'] = price.split('.');
				return {
					integer,
					decimal: `.${decimal}`,
				};
			},
		},
		methods: {
			onButtonClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.isGeditModulePaid) {
					this.doJump();
				} else {
					this.runModulePayFlow();
				}
			},
			doJump() {
				if (this.data.jumpLink?.type) {
					navigateJumpLink(this.data.jumpLink, {
						apiRequest: this.$apiRequest,
					});
					return;
				}
				const jumpUrl = this.data.jumpUrl;
				if (!jumpUrl) {
					console.warn('JumpLinkFeatured: 未配置跳转链接');
					return;
				}
				window.location.href = jumpUrl;
			},
			runModulePayFlow() {
				if (this.editable) return;
				if (!this.isGeditRealPay) return;
				if (this.isGeditModulePaid) return;
				const oId = this.geditPayModuleId;
				if (!oId) return;
				const requestPay = this.geditPay?.requestPay;
				if (typeof requestPay !== 'function') return;
				Promise.resolve(requestPay(oId)).catch(() => {});
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-pay-jumplink-featured {
		&--edit {
			border: 1px solid transparent;
			border-radius: 16px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-pay-jumplink-featured__card {
		background: #fff;
		border-radius: 12px;
		padding: 15px;
		box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
	}

	.g-block-pay-jumplink-featured__badge {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding: 4px 10px;
		border-radius: 6px;
		color: #fff;
		font-size: 12px;
		line-height: 1.2;
		font-weight: 500;

		.mbm-iconfont {
			font-size: 12px;
		}
	}

	.g-block-pay-jumplink-featured__main {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
		margin-top: 14px;
	}

	.g-block-pay-jumplink-featured__main-left {
		min-width: 0;
		flex: 1;
	}

	.g-block-pay-jumplink-featured__title {
		margin: 0;
		font-size: 22px;
		font-weight: 700;
		line-height: 1.35;
		color: #1a1a1a;
	}

	.g-block-pay-jumplink-featured__subtitle {
		margin: 8px 0 0;
		font-size: 13px;
		line-height: 1.4;
		color: #8a8f99;
	}

	.g-block-pay-jumplink-featured__price {
		flex-shrink: 0;
		display: inline-flex;
		align-items: flex-end;
		color: #ff2b2b;
		font-weight: 700;
		line-height: 1;
	}

	.g-block-pay-jumplink-featured__currency {
		font-size: 16px;
		margin-right: 2px;
		margin-top: 10px;
	}

	.g-block-pay-jumplink-featured__integer {
		font-size: 40px;
		letter-spacing: -1px;
	}

	.g-block-pay-jumplink-featured__decimal {
		font-size: 16px;
		margin-top: 6px;
	}

	.g-block-pay-jumplink-featured__divider {
		margin: 16px 0;
		height: 1px;
		background: #eef0f4;
	}

	.g-block-pay-jumplink-featured__footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		padding: 12px 12px 12px 14px;
		border-radius: 12px;
		background: #f2f5ff;
	}

	.g-block-pay-jumplink-featured__assurance {
		display: flex;
		align-items: center;
		gap: 6px;
		min-width: 0;
		flex: 1;
		font-size: 13px;
		color: #86909c;
		line-height: 1.3;

		.mbm-iconfont {
			flex-shrink: 0;
			font-size: 22px;
		}

		span {
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.g-block-pay-jumplink-featured__btn {
		flex-shrink: 0;
		display: inline-flex;
		align-items: center;
		gap: 8px;
		padding: 10px 24px;
		border-radius: 10px;
		font-size: 14px;
		font-weight: 600;
		line-height: 1;
		cursor: pointer;
		user-select: none;
	}

	.g-block-pay-jumplink-featured__btn-arrow {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: #fff;

		.mbm-iconfont {
			font-size: 12px;
		}
	}

	.g-block-pay-jumplink-featured--h5 {
		.g-block-pay-jumplink-featured__card {
			border-radius: 0.24rem;
			padding: 0.3rem;
			box-shadow: 0 0 0.32rem rgba(0, 0, 0, 0.1);
		}

		.g-block-pay-jumplink-featured__badge {
			padding: 0.08rem 0.2rem;
			border-radius: 0.12rem;
			font-size: 0.24rem;
			gap: 0.08rem;

			.mbm-iconfont {
				font-size: 0.24rem;
			}
		}

		.g-block-pay-jumplink-featured__main {
			gap: 0.32rem;
			margin-top: 0.28rem;
		}

		.g-block-pay-jumplink-featured__title {
			font-size: 0.4rem;
		}

		.g-block-pay-jumplink-featured__subtitle {
			margin-top: 0.16rem;
			font-size: 0.24rem;
		}

		.g-block-pay-jumplink-featured__currency {
			font-size: 0.32rem;
			margin-top: 0.2rem;
		}

		.g-block-pay-jumplink-featured__integer {
			font-size: 0.8rem;
		}

		.g-block-pay-jumplink-featured__decimal {
			font-size: 0.32rem;
			margin-top: 0.12rem;
		}

		.g-block-pay-jumplink-featured__divider {
			margin: 0.32rem 0;
		}

		.g-block-pay-jumplink-featured__footer {
			gap: 0.24rem;
			padding: 0.24rem 0.24rem 0.24rem 0.28rem;
			border-radius: 0.24rem;
		}

		.g-block-pay-jumplink-featured__assurance {
			gap: 0.12rem;
			font-size: 0.24rem;

			.mbm-iconfont {
				font-size: 0.38rem;
			}
		}

		.g-block-pay-jumplink-featured__btn {
			gap: 0.16rem;
			padding: 0.18rem 0.40rem;
			border-radius: .2rem;
			font-size: 0.24rem;
		}

		.g-block-pay-jumplink-featured__btn-arrow {
			width: 0.34rem;
			height: 0.34rem;

			.mbm-iconfont {
				font-size: 0.24rem;
			}
		}
	}
</style>
